module.exports = __webpack_public_path__ + "static/img/gift1.b7c0f8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/gtn/assets/activity/shuang12/gift1.png
// module id = N+15
// module chunks = 86